import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-light-gray-100 flex flex-row p-5 justify-center items-center gap-3" }
const _hoisted_2 = { class: "uppercase text-[25px] font-black" }
const _hoisted_3 = { class: "p-10 pb-8 flex flex-col gap-5" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "text-3xl font-bold" }
const _hoisted_6 = { class: "flex flex-row gap-3 p-5" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "workbean workbean-copy" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

import { IonContent, IonButton, IonModal, IonFooter, IonToolbar } from "@ionic/vue"
  import { onMounted, computed } from "vue"
  import { useResourcesStore } from "@/store/resources"
  import { useUserStore } from "@/store/user"
  import { useMetadataStore } from "@/store/metadata"
  import { toastController } from "@ionic/core"
  import { useRoute, useRouter } from "vue-router"
  import { includes } from "lodash"

  import explorerImage from "@/assets/images/worksona/icon/explorer.svg"
  import innocentImage from "@/assets/images/worksona/icon/innocent.svg"
  import innovatorImage from "@/assets/images/worksona/icon/innovator.svg"
  import inventorImage from "@/assets/images/worksona/icon/inventor.svg"
  import jesterImage from "@/assets/images/worksona/icon/jester.svg"
  import philosopherImage from "@/assets/images/worksona/icon/philosopher.svg"
  import realistImage from "@/assets/images/worksona/icon/realist.svg"
  import supporterImage from "@/assets/images/worksona/icon/supporter.svg"
  import sweetheartImage from "@/assets/images/worksona/icon/sweetheart.svg"
  import warriorImage from "@/assets/images/worksona/icon/warrior.svg"
  import rulerImage from "@/assets/images/worksona/icon/ruler.svg"
  import rebelImage from "@/assets/images/worksona/icon/rebel.svg"
  import fbIcon from "@/assets/images/social-media/facebook-icon.svg"
  import linkedinIcon from "@/assets/images/social-media/linkedin-icon.svg"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorksonaResultPage',
  setup(__props) {

  const worksonaIcon = {
    explorer: explorerImage,
    innocent: innocentImage,
    innovator: innovatorImage,
    inventor: inventorImage,
    jester: jesterImage,
    philosopher: philosopherImage,
    realist: realistImage,
    supporter: supporterImage,
    sweetheart: sweetheartImage,
    warrior: warriorImage,
    ruler: rulerImage,
    rebel: rebelImage,
  }

  const resources = useResourcesStore()
  const metadataStore = useMetadataStore()
  const route = useRoute()
  const router = useRouter()
  const user = useUserStore()
  const meta = computed(() => ({
    title: resources.worksona.name,
    type: "website",
    description: resources.worksona.description,
    image: resources.worksona.image_with_icon,
    url: window.location.href,
    site: window.location.href,
  }))

  /**
   * copy URL
   */
  const copyUrl = async () => {
    navigator.clipboard.writeText(window.location.href)

    const toast = await toastController.create({
      message: "Worksona result copied to clipboard",
      duration: 3000,
      position: "top",
      color: "info",
    })
    await toast.present()
  }
  /**
   * generate profile url
   */
  const getURL = () => {
    let fullName = user.customerDetails.profile.name.full_name
    if (!fullName || fullName.length === 0) {
      fullName = `${user.customerDetails.profile.name.first_name} ${user.customerDetails.profile.name.last_name}`
    }
    return fullName.toLowerCase().replaceAll(" ", "-")
  }

  onMounted(async () => {
    if (includes(["explorer", "innocent", "innovator", "inventor", "jester", "philosopher", "realist", "supporter", "sweetheart", "warrior", "ruler", "rebel"], route.params.type)) {
      await resources.retrieveWorksonaResult(route.params.type as string)
      metadataStore.details.title = meta.value.title
      metadataStore.details.description = meta.value.description
      metadataStore.details.og = { ...metadataStore.details.og, ...meta.value }
      metadataStore.details.twitter = { ...metadataStore.details.twitter, ...meta.value }
    } else router.push("/survey/worksona")
  })

return (_ctx: any,_cache: any) => {
  const _component_ShareNetwork = _resolveComponent("ShareNetwork")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonContent), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(resources).worksona.archetype), 1)
        ]),
        _createElementVNode("div", _hoisted_3, [
          (_unref(resources).worksona.image_with_icon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                class: "object-contain rounded-3xl h-[25rem] w-fit mx-auto",
                src: _unref(resources).worksona.image_with_icon,
                alt: _unref(resources).worksona.name
              }, null, 8, _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "text-white px-10 py-5 rounded-[8px] w-fit-content relative bg-primary-violet mx-auto",
            style: _normalizeStyle({ backgroundColor: _unref(resources).worksona.color })
          }, [
            _createElementVNode("blockquote", _hoisted_5, _toDisplayString(_unref(resources).worksona.life_quote), 1),
            _createElementVNode("div", {
              class: "w-0 h-0 absolute -left-[9px] top-1",
              style: _normalizeStyle({ borderTop: '10px solid transparent', borderBottom: '10px solid transparent', borderRight: `10px solid ${_unref(resources).worksona.color}` })
            }, null, 4)
          ], 4)
        ])
      ]),
      _: 1
    }),
    _createVNode(_unref(IonFooter), { class: "ion-no-border h-32 mb-16" }, {
      default: _withCtx(() => [
        _createVNode(_unref(IonToolbar), { class: "p-5" }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonButton), {
              expand: "block",
              style: _normalizeStyle(`--ion-color-primary: ${_unref(resources).worksona.color}`),
              onClick: _cache[0] || (_cache[0] = () => _unref(router).push(`/talent-profile/${_unref(user).customerDetails.profile.user_id}/${getURL()}/worksona`))
            }, {
              default: _withCtx(() => [
                _createTextVNode("View full result")
              ]),
              _: 1
            }, 8, ["style"]),
            _createVNode(_unref(IonButton), {
              id: "open-modal",
              expand: "block"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Share Worksona result")
              ]),
              _: 1
            }),
            _createVNode(_unref(IonModal), {
              ref: "modal",
              trigger: "open-modal",
              "initial-breakpoint": 0.2,
              breakpoints: [0, 0.2, 0.5, 0.3]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonContent), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ShareNetwork, {
                        network: "facebook",
                        url: _unref(meta).url,
                        media: _unref(meta).image,
                        title: _unref(meta).title,
                        description: _unref(meta).description,
                        hashtags: `workbean,worksona,${_unref(resources).worksona.codename}`,
                        class: "bg-primary-black w-[45px] h-[45px] rounded-[8px]"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(fbIcon),
                            alt: "Share to facebook",
                            class: "w-full h-full object-fit p-[10px]"
                          }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      }, 8, ["url", "media", "title", "description", "hashtags"]),
                      _createVNode(_component_ShareNetwork, {
                        network: "linkedin",
                        url: _unref(meta).url,
                        media: _unref(meta).image,
                        title: _unref(meta).title,
                        description: _unref(meta).description,
                        hashtags: `workbean,worksona,${_unref(resources).worksona.codename}`,
                        class: "bg-primary-black w-[45px] h-[45px] rounded-[8px]"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: _unref(linkedinIcon),
                            alt: "Share to LinkedIn",
                            class: "w-full h-full object-fit p-[10px]"
                          }, null, 8, _hoisted_8)
                        ]),
                        _: 1
                      }, 8, ["url", "media", "title", "description", "hashtags"]),
                      _createElementVNode("button", {
                        class: "bg-primary-black text-white w-[45px] h-[45px] rounded-[8px] p-[2px]",
                        onClick: copyUrl
                      }, _hoisted_10)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["initial-breakpoint", "breakpoints"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})